import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';

export const OnRamperDialog = ({ dialogOpen, setDialogOpen, onRamperSrc }) => {
  const theme = useTheme();
  return (
    <Dialog
      onClose={() => {
        setDialogOpen(false);
      }}
      open={dialogOpen}
      sx={{
        width: '100%',
        height: '100%',
        '& .MuiPaper-root': {
          height: '60%',
          width: '100%',
          background: 'transparent',
        },
      }}
    >
      <DialogContent
        sx={{
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: 10,
            background: theme.palette.background.elevation[16],
          }}
        >
          <iframe
            src={onRamperSrc}
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '10px',
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
